export const useStyles = (theme) => ({
  root: {
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    backgroundPosition: "right center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  textStyle: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    [theme.breakpoints.down(640)]: { fontWeight: "bold" },
  },
  inputRoot: {
    height: 50,
    [theme.breakpoints.down(640)]: {
      backgroundColor: "#fff",
      color: "#181818",
    },
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    background: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
});
